module.exports = __webpack_public_path__ + "img/V30.f0cff3a0.jpg";